function _escape(str = "") {
  let r = /[&<>"'\/]/g;
  return (
    "" +
    str.replace(r, (m) => {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#x27;",
        "/": "&#x2F;",
      }[m];
    })
  );
}

export class SafeString {
  s: string;
  constructor(s: string) {
    this.s = s;
  }
  toString() {
    return <string>this.s;
  }
}

export function Domifier(str: string) {
  const dom = new DOMParser();
  return dom.parseFromString(str, "text/html").querySelector("body").firstChild as Element;
}

export function Hatch(tmpl: any, ...vs: any): SafeString {
  let result = "";
  for (let i = 0; i < vs.length; i++) {
    if (vs[i] instanceof SafeString) result += tmpl[i] + vs[i].toString();
    else result += tmpl[i] + _escape(String(vs[i]));
  }
  return new SafeString(result + tmpl[vs.length]);
}

export function HatchMap(list: any, func: Function) {
  let mapped = list.map(func);
  return new SafeString(mapped.map((v: any) => (v instanceof SafeString ? v : _escape(String(v)))).join(""));
}
